// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"ab28c129","727":"6a06af92","728":"705efaf7","766":"f88a0f9b","886":"d9d48f8f"}[chunkId] + ".chunk.css";
};